import React, { Component } from "react";
import FileUpload  from '../../../Containers/BulkValidation';
const inlineStyles = {
  PaddingLeft: { paddingleft: 0 },
  MarginTop: { marginTop: 0 },
  FileUpload: { fontSize: 80, fontWeight: 200, opacity: 0.5, left: 40, top: 10 }
};

class BulkEmailVerification extends Component {
  render() {
    return (
      <div className="col-md-6 col-sm-12 col-xs-12">
        <div className="x_panel emails_box">
          <div className="x_title">
          <h2 className="float-left">Bulk Email Verification</h2>
            <ul className="nav navbar-right panel_toolbox">
              <li />
            </ul>
            <div className="clearfix" />
          </div>
          <div className="x_content">
            <FileUpload />
          </div>
        </div>
        {/* after form */}
      </div>
    );
  }
}

export default BulkEmailVerification;



// WEBPACK FOOTER //
// ./src/components/EmailVerification/EmailVerificationContainer/BulkEmailVerification.js